import { apiGet } from '../api'

export const get_recruitment_summary = query => {
  return apiGet({
    endpoint: `recruitment/summary${query ? `?${query}` : ''}`
  })
}
